import React from "react";

import RbAlertContext from "components/RbAlertProvider/RbAlertContext";

function useAlert() {
  const context = React.useContext(RbAlertContext);

  if (!context) {
    throw new Error(`useAlert must be used within a RbAlertProvider`);
  }

  return context;
}

export default useAlert;
